export default __webpack_public_path__ + "static/media/singapore.28277b86.jpeg";